export default __webpack_public_path__ + "static/banner-car-insurance-payout-cc8a8a8d11862fe3769363d3c92eeb8b.jpg";